import _objectSpread from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getCountryCode as _getCountryCode } from '@/api/phoneLogin';
import { getInternalByMobile, sendAccountProbe, accountProbeTips, accountProbePreTips } from '@/api/oaProbe';
export default {
  name: 'OaProbe',
  data: function data() {
    var _this = this;

    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        _this.valid.phone = false;
        callback();
      } else if (_this.selectCode === '+86' && !/^\d{11}$/.test(value)) {
        _this.valid.phone = false;
        _this.phoneActive || _this.phoneInputValid ? callback() : callback(new Error('手机号码格式错误'));
      } else if (_this.selectCode !== '+86' && !/^\d{7,11}$/.test(value)) {
        _this.valid.phone = false;
        _this.phoneActive ? callback() : callback(new Error('手机号码格式错误'));
      } else {
        _this.valid.phone = true;
        callback();
      }
    };

    return {
      title: '账号即将到期',
      expiredDate: '',
      loginForm: {
        phone: '' // 龙湖对接人手机号

      },
      // 表单是否符合填写规则
      valid: {
        phone: false
      },
      staffUserName: '',
      // 龙湖对接人姓名 - 页面显示用
      account: '',
      // 对接人oa账号 - 接口入参用
      selectCode: '+86',
      // 区号
      areaCodeList: [],
      // 国际区号列表
      phoneActive: false,
      // 手机号输入框是否获取焦点
      phoneInputValid: false,
      disabledPhoneInput: true,
      // 手机号区域是否允许输入
      confirmStaffName: '',
      confirmStaffPhone: '',
      // 登录参数
      domains: [],
      wudomain: '',
      url: '',
      disabledApplyBtn: true,
      // 是否允许发送申请
      sendProbeLoading: false,
      staffQueryBusy: false,
      // 表单校验
      rules: {
        phone: [{
          validator: validatePhone,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['oaProbeInfo'])), {}, {
    /**
     * @func 探活类型-type
     * @desc warn：非强制探活，用户可以取消后登录;
     * @desc force：强制探活，必须等对接人审批通过后才能登录
     */
    probeType: function probeType() {
      return this.oaProbeInfo.type;
    },
    warningText: function warningText() {
      return "\u60A8\u7684\u8D26\u53F7\u5373\u5C06\u5230\u8FBE\u4F7F\u7528\u671F\u9650(".concat(this.expiredDate, ")\uFF0C\u4E3A\u4FDD\u8BC1\u8D26\u53F7\u5B89\u5168\uFF0C\u9700\u8981\u60A8\u5728\u9F99\u6E56\u5BF9\u63A5\u7684\u540C\u4E8B\u5E2E\u60A8\u5B8C\u6210\u9A8C\u8BC1\uFF0C\u5230\u671F\u672A\u9A8C\u8BC1\u5C06\u65E0\u6CD5\u4F7F\u7528");
    },
    // 已发送待办，待办待确认提示文案
    todoConfirmText: function todoConfirmText() {
      var pre = '已通过云图梭-工作台-任务向您的龙湖对接同事';
      var after = '发送验证申请，请耐心等待或联系其处理，完成验证后才可继续使用';
      return "".concat(pre, " ").concat(this.confirmStaffName).concat(this.confirmStaffPhone ? '（' + this.confirmStaffPhone + '）' : '', " ").concat(after);
    },
    // 探活主体内容
    probeText: function probeText() {
      return this.probeType === 'force' ? '您的账号长时间未使用或已到达使用期限，为保证账号安全，需要您在龙湖对接的同事帮您验证激活。' : this.probeType === 'warn' ? this.warningText : this.probeType === 'todoConfirm' ? this.todoConfirmText : this.warningText;
    },
    probeTitle: function probeTitle() {
      return this.probeType === 'force' ? '账号锁定提醒' : this.probeType === 'warn' ? '账号即将到期' : this.probeType === 'todoConfirm' ? '账号验证中' : '账号锁定提醒';
    }
  }),
  watch: {
    'loginForm.phone': function loginFormPhone(value) {
      this.staffUserName = '';
      this.loginForm.phone = this.loginForm.phone.replace(/\D/g, '');
      var valid_86 = this.selectCode === '+86' && /^\d{11}$/.test(value);
      var valid_other = this.selectCode !== '+86' && /^\d{7,11}$/.test(value);
      this.phoneInputValid = valid_86 || valid_other;
    },
    // 号码格式正确，查询号码对应对接人
    'phoneInputValid': function phoneInputValid(valid) {
      if (!valid) {
        this.disabledApplyBtn = true;
      } else {
        this.getStaffInfoByPhone();
      }
    },
    probeType: {
      handler: function handler(type) {
        // 如果是等待待办确认，查询待办龙湖对接人信息
        if (type === 'todoConfirm') {
          this.getTodoConfirmStaffInfo();
        } else {
          this.getProbeLastDate();
        }
      },
      immediate: true
    }
  },
  created: function created() {
    this.getCountryCode(); // 获取国际区号，手机号 +86
  },
  methods: _objectSpread(_objectSpread({}, require('@/assets/js/redirect.js').methods), {}, {
    /**
     * @func 获取国际区号
     */
    getCountryCode: function getCountryCode() {
      var _this2 = this;

      _getCountryCode().then(function (res) {
        var _ref = res || {},
            code = _ref.code,
            data = _ref.data,
            message = _ref.message;

        if (code === '1') {
          _this2.areaCodeList = data;
        } else {
          _this2.$message.error(message);
        }
      }).catch(function (e) {
        console.log(e);
      });
    },

    /**
     * @func 非强制探活，点击稍后处理，允许登录二次确认
     */
    doNextTime: function doNextTime() {
      var _this3 = this;

      var txt = (this.expiredDate ? "\u8BF7\u4E8E".concat(this.expiredDate, "\u524D") : '请尽快') + '完成验证，否则将无法继续使用。确认稍后处理？';
      this.$confirm(txt, '提示', {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        center: true,
        customClass: 'oa-check-confirm-poper'
      }).then(function () {
        _this3.redirectToLogin();
      }).catch(function (e) {
        console.warn(e);
      });
    },

    /**
     * @func 根据手机号查询账号信息
     * @param {String} mobile 手机号
     * @param {String} phoneAreaCode 区号
     */
    getStaffInfoByPhone: function getStaffInfoByPhone() {
      var _this4 = this;

      this.disabledApplyBtn = true;
      this.staffQueryBusy = true;
      getInternalByMobile({
        userName: this.oaProbeInfo.userName || '',
        mobile: this.loginForm.phone,
        phoneAreaCode: this.selectCode
      }).then(function (res) {
        var _ref2 = res || {},
            code = _ref2.code,
            data = _ref2.data,
            message = _ref2.message;

        if (code === '1') {
          _this4.staffUserName = data.realName; // 回显对接人姓名

          _this4.account = data.account; // 对接人oa账号

          _this4.disabledApplyBtn = false; // 允许发送申请
        } else {
          _this4.$message.error(message);
        }
      }).catch(function (e) {
        console.log(e);
      }).finally(function () {
        _this4.staffQueryBusy = false;
      });
    },

    /**
     * @func 发送申请按钮，申请激活账号
     * @desc 20221019 新增 自动查询龙湖对接人功能，为兼容测试环境手机号脱敏，不再校验手机号的填写
     */
    sendProbe: function sendProbe() {
      var _this5 = this;

      this.sendProbeLoading = true;

      if (!this.account) {
        this.$message.error('未找到龙湖对接人账号信息，请稍后重试');
        return;
      }

      sendAccountProbe({
        userName: this.oaProbeInfo.userName,
        destAccount: this.account
      }).then(function (res) {
        var code = res.code,
            message = res.message;

        if (code === '1') {
          _this5.$alert('激活待办已发送给对接同事，请等待对方确认', '提示', {
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
            center: true,
            customClass: 'oa-check-confirm-poper'
          }).then(function () {
            _this5.handleSendProbeSuccess();
          });
        } else {
          _this5.$message.error(message);
        }
      }).catch(function (e) {
        console.log(e);
      }).finally(function () {
        _this5.sendProbeLoading = false;
      });
    },

    /**
     * @func 发送成功后，跳转响应处理
     * @desc 强制探活，返回登陆页；非强制探活，直接登录
     */
    handleSendProbeSuccess: function handleSendProbeSuccess() {
      if (this.probeType === 'warn') {
        this.redirectToLogin();
        this.$utils.zhugeTrack('web-点击-账号探活-非强制探活-待办发送成功');
      } else if (this.probeType === 'force') {
        this.$store.commit('init/SET_OA_PROBE_INFO', Object.assign({}, this.oaProbeInfo, {
          type: 'todoConfirm'
        }));
        this.$utils.zhugeTrack('web-点击-账号探活-强制探活-待办发送成功');
      }
    },

    /**
     * @func 前往登录
     */
    redirectToLogin: function redirectToLogin() {
      var _this$oaProbeInfo = this.oaProbeInfo,
          domains = _this$oaProbeInfo.domains,
          wudomain = _this$oaProbeInfo.wudomain,
          url = _this$oaProbeInfo.url;
      domains && (this.domains = decodeURIComponent(domains).split(','));
      wudomain && (this.wudomain = wudomain);
      url && (this.url = url);

      if (this.domains.length === 0 && !this.wudomain) {
        this.$message.error('缺少必要的参数，请刷新重试或联系我们');
        return;
      }

      this.redirect();
      this.$utils.zhugeTrack('web-点击-账号探活-用户确认稍后处理');
    },

    /**
     * @func 返回按钮
     */
    goBack: function goBack(from) {
      this.$store.commit('login/SET_LOGINTYPE', 'phone');

      if (from === 'force') {
        this.$utils.zhugeTrack('web-点击-账号探活-强制探活-暂不登录');
      }
    },

    /**
     * @func 获取确认待办信息的龙湖对接员工信息
     */
    getTodoConfirmStaffInfo: function getTodoConfirmStaffInfo() {
      var _this6 = this;

      var _ref3 = this.oaProbeInfo || {},
          userName = _ref3.userName;

      accountProbeTips({
        userName: userName
      }).then(function (res) {
        var _ref4 = res || {},
            code = _ref4.code,
            data = _ref4.data,
            message = _ref4.message;

        if (code === '1') {
          _this6.confirmStaffName = data.maskedRealName;
          _this6.confirmStaffPhone = data.maskedMobile;
        } else {
          _this6.$message.error(message);
        }
      }).catch(function (e) {
        console.warn(e);
      });
    },

    /**
     * @func 非强制探活，获取账号最后使用期限
     */
    getProbeLastDate: function getProbeLastDate() {
      var _this7 = this;

      this.disabledPhoneInput = true;
      this.staffQueryBusy = true;
      this.disabledApplyBtn = true;

      var _ref5 = this.oaProbeInfo || {},
          userName = _ref5.userName;

      accountProbePreTips({
        userName: userName
      }).then(function (res) {
        var _ref6 = res || {},
            code = _ref6.code,
            data = _ref6.data,
            message = _ref6.message;

        if (code === '1') {
          _this7.expiredDate = data.expiredDate;
          _this7.loginForm.phone = data.mobile || '';
          _this7.account = data.account; // 接口入参用

          _this7.staffUserName = data.currentStaffRealName || data.account; // 显示用
        } else {
          _this7.$message.error(message);
        }
      }).catch(function (e) {
        console.warn(e);
      }).finally(function () {
        // 如果接口返回无龙湖对接人手机号或姓名，则允许用户手动输入
        if (!_this7.loginForm.phone && !_this7.staffUserName) {
          _this7.disabledPhoneInput = false;
        } else {
          _this7.disabledApplyBtn = false;
        }

        _this7.staffQueryBusy = false;
      });
    }
  })
};